/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.moderation.queryStatuses'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  queueCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  queueIndex: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  queueSeed: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  includeAllUserRecords: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  subject: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'uri' })),
  comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  reportedAfter: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  reportedBefore: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  reviewedAfter: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  hostingDeletedAfter: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  hostingDeletedBefore: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  hostingUpdatedAfter: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  hostingUpdatedBefore: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  hostingStatuses: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  ),
  reviewedBefore: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  includeMuted: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  onlyMuted: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  reviewState: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: [
        'tools.ozone.moderation.defs#reviewOpen',
        'tools.ozone.moderation.defs#reviewClosed',
        'tools.ozone.moderation.defs#reviewEscalated',
        'tools.ozone.moderation.defs#reviewNone',
      ]
    }>(),
  ),
  ignoreSubjects: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'uri' })),
  ),
  lastReviewedBy: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'did' }),
  ),
  sortField: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.enum([
        'lastReviewedAt',
        'lastReportedAt',
        'reportedRecordsCount',
        'takendownRecordsCount',
        'priorityScore',
      ]),
      'lastReportedAt',
    ),
  ),
  sortDirection: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.enum(['asc', 'desc']), 'desc'),
  ),
  takendown: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  appealed: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  tags: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), { maxLength: 25 }),
  ),
  excludeTags: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  collections: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'nsid' }), {
      maxLength: 20,
    }),
  ),
  subjectType: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: ['account', 'record', 'conversation']
    }>(),
  ),
  minAccountSuspendCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  minReportedRecordsCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  minTakendownRecordsCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  minPriorityScore: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.integer({ minimum: 0, maximum: 100 }),
  ),
  minStrikeCount: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.integer({ minimum: 1 }),
  ),
  ageAssuranceState: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: ['pending', 'assured', 'unknown', 'reset', 'blocked']
    }>(),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  subjectStatuses: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ModerationDefs.SubjectStatusView>(
      (() => ModerationDefs.subjectStatusView) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** View moderation statuses of subjects (record or repo). */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
